export default __webpack_public_path__ + "static/SuisseIntl-Bold-8fc10edd86a7638255e173b22ce06fdb.woff";